import React, { useState } from 'react';

const CarRentalForm = ({ onSave, onCancel, initialData }) => {
  const [formData, setFormData] = useState({
    title: initialData?.title || '',
    rentalAgency: initialData?.rentalAgency || '',
    pickupLocation: initialData?.pickupLocation || '',
    pickupDate: initialData?.pickupDate || '',
    pickupTime: initialData?.pickupTime || '',
    dropoffLocation: initialData?.dropoffLocation || '',
    dropoffDate: initialData?.dropoffDate || '',
    dropoffTime: initialData?.dropoffTime || '',
    carClass: initialData?.carClass || '',
    confirmationNumber: initialData?.confirmationNumber || '',
    phoneNumber: initialData?.phoneNumber || '',
    description: initialData?.description || '',
    price: initialData?.price || '',
    photos: initialData?.photos || [],
    documents: initialData?.documents || []
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({
      ...formData,
      price: parseFloat(formData.price) || 0
    });
  };

  const handlePhotoUpload = (e) => {
    const files = Array.from(e.target.files);
    const newPhotos = files.map(file => ({
      id: Date.now() + Math.random(),
      name: file.name,
      url: URL.createObjectURL(file),
      file
    }));
    setFormData(prev => ({
      ...prev,
      photos: [...prev.photos, ...newPhotos]
    }));
  };

  const handleDocumentUpload = (e) => {
    const files = Array.from(e.target.files);
    const newDocs = files.map(file => ({
      id: Date.now() + Math.random(),
      name: file.name,
      url: URL.createObjectURL(file),
      file
    }));
    setFormData(prev => ({
      ...prev,
      documents: [...prev.documents, ...newDocs]
    }));
  };

  const removePhoto = (photoId) => {
    setFormData(prev => ({
      ...prev,
      photos: prev.photos.filter(p => p.id !== photoId)
    }));
  };

  const removeDocument = (docId) => {
    setFormData(prev => ({
      ...prev,
      documents: prev.documents.filter(d => d.id !== docId)
    }));
  };

  return (
    <form onSubmit={handleSubmit} className="component-form car-rental-form">
      <div className="form-section">
        <h4>Car Rental Information</h4>
        
        <div className="form-group">
          <label>Title/Description*</label>
          <input
            type="text"
            value={formData.title}
            onChange={(e) => setFormData({...formData, title: e.target.value})}
            placeholder="e.g., 7-Day Economy Car Rental"
            required
          />
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Rental Agency*</label>
            <input
              type="text"
              value={formData.rentalAgency}
              onChange={(e) => setFormData({...formData, rentalAgency: e.target.value})}
              placeholder="e.g., Enterprise, Hertz, Avis"
              required
            />
          </div>
          <div className="form-group">
            <label>Car Class*</label>
            <input
              type="text"
              value={formData.carClass}
              onChange={(e) => setFormData({...formData, carClass: e.target.value})}
              placeholder="e.g., Economy, SUV, Luxury"
              required
            />
          </div>
        </div>
      </div>

      <div className="form-section">
        <h4>Pickup Information</h4>
        
        <div className="form-group">
          <label>Pickup Location*</label>
          <input
            type="text"
            value={formData.pickupLocation}
            onChange={(e) => setFormData({...formData, pickupLocation: e.target.value})}
            placeholder="e.g., LAX Airport, Downtown Office"
            required
          />
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Pickup Date*</label>
            <input
              type="date"
              value={formData.pickupDate}
              onChange={(e) => setFormData({...formData, pickupDate: e.target.value})}
              required
            />
          </div>
          <div className="form-group">
            <label>Pickup Time</label>
            <input
              type="time"
              value={formData.pickupTime}
              onChange={(e) => setFormData({...formData, pickupTime: e.target.value})}
            />
          </div>
        </div>
      </div>

      <div className="form-section">
        <h4>Dropoff Information</h4>
        
        <div className="form-group">
          <label>Dropoff Location*</label>
          <input
            type="text"
            value={formData.dropoffLocation}
            onChange={(e) => setFormData({...formData, dropoffLocation: e.target.value})}
            placeholder="e.g., LAX Airport, Downtown Office"
            required
          />
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Dropoff Date*</label>
            <input
              type="date"
              value={formData.dropoffDate}
              onChange={(e) => setFormData({...formData, dropoffDate: e.target.value})}
              required
            />
          </div>
          <div className="form-group">
            <label>Dropoff Time</label>
            <input
              type="time"
              value={formData.dropoffTime}
              onChange={(e) => setFormData({...formData, dropoffTime: e.target.value})}
            />
          </div>
        </div>
      </div>

      <div className="form-section">
        <h4>Booking Details</h4>
        
        <div className="form-row">
          <div className="form-group">
            <label>Confirmation Number</label>
            <input
              type="text"
              value={formData.confirmationNumber}
              onChange={(e) => setFormData({...formData, confirmationNumber: e.target.value})}
              placeholder="e.g., ABC123456"
            />
          </div>
          <div className="form-group">
            <label>Phone Number</label>
            <input
              type="tel"
              value={formData.phoneNumber}
              onChange={(e) => setFormData({...formData, phoneNumber: e.target.value})}
              placeholder="e.g., (555) 123-4567"
            />
          </div>
          <div className="form-group">
            <label>Price*</label>
            <input
              type="number"
              value={formData.price}
              onChange={(e) => setFormData({...formData, price: e.target.value})}
              placeholder="0.00"
              min="0"
              step="0.01"
              required
            />
          </div>
        </div>

        <div className="form-group">
          <label>Additional Description</label>
          <textarea
            value={formData.description}
            onChange={(e) => setFormData({...formData, description: e.target.value})}
            placeholder="Add any additional details about this car rental..."
            rows="3"
          />
        </div>
      </div>

      <div className="form-section">
        <h4>Attachments</h4>
        
        <div className="form-group">
          <label>Photos</label>
          <input
            type="file"
            multiple
            accept="image/*"
            onChange={handlePhotoUpload}
            className="file-input"
          />
          {formData.photos.length > 0 && (
            <div className="file-list">
              {formData.photos.map(photo => (
                <div key={photo.id} className="file-item">
                  <span>{photo.name}</span>
                  <button type="button" onClick={() => removePhoto(photo.id)}>×</button>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="form-group">
          <label>Documents</label>
          <input
            type="file"
            multiple
            accept=".pdf,.doc,.docx"
            onChange={handleDocumentUpload}
            className="file-input"
          />
          {formData.documents.length > 0 && (
            <div className="file-list">
              {formData.documents.map(doc => (
                <div key={doc.id} className="file-item">
                  <span>{doc.name}</span>
                  <button type="button" onClick={() => removeDocument(doc.id)}>×</button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <div className="form-actions">
        <button type="button" className="btn btn-secondary" onClick={onCancel}>
          Cancel
        </button>
        <button type="submit" className="btn btn-primary">
          {initialData ? 'Update' : 'Add'} Car Rental
        </button>
      </div>
    </form>
  );
};

export default CarRentalForm;
